export const mediaKeys = {
  all: [{ module: 'media' }] as const,
  filesLists: () => [{ ...mediaKeys.all[0], scope: 'filesList' }] as const,
  filesList: (jobId: string) => [{ ...mediaKeys.filesLists()[0], jobId }] as const,
  analysisProgresses: () => [{ ...mediaKeys.all[0], scope: 'analysisProgress' }] as const,
  analysisProgress: (jobId: string) => [{ ...mediaKeys.analysisProgresses()[0], jobId }] as const,
  legacyAnalysisJobs: () => [{ ...mediaKeys.all[0], scope: 'legacyAnalysisJob' }] as const,
  legacyAnalysisJob: (mediaId: string) => [{ ...mediaKeys.legacyAnalysisJobs()[0], mediaId }] as const,
};
